export default "__VITE_ASSET__BbZ6CScL__"